const config = {

  scrollToOptions: {
    container: 'body',
    easing: 'ease',
    offset: 0,
    cancelable: true,
    x: false,
    y: true
  },

  opportunityList: {
    pagination: {
      byPage: 10
    }
  }
}

export default config
